import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=32faae15&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"
import style0 from "./Logo.vue?vue&type=style&index=0&id=32faae15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32faae15",
  null
  
)

export default component.exports